/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-20 10:44:54
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-18 09:04:00
 * @FilePath: /dbrank_b/src/routes/visualChart/components/TooltipDrawer/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import PropTypes from 'prop-types'
import Tooltip from '../Tooltip';
import Drawer from '../Drawer';
import Button from '../Button';

class TooltipDrawer extends React.Component {
  static propTypes = {
    formContent: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
  }
  
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    }
  }

  componentDidMount() {
    window.addEventListener('click', this.bindEvent);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.bindEvent);
  }

  bindEvent = (e) => {
    const target = e.target;
    const isContains = this.elementRef.contains(target)
    const isButtonContains = this.buttonRef.contains(target)

    if (!isContains && !isButtonContains) {
      this.setState({ visible: false })
    }
  }

  openEdit = () => {
    this.setState({ visible: true })
  }
  closeEdit = () => {
    this.setState({ visible: false })
  }


  render () {
    const { formContent, style, className } = this.props;
    const { visible } = this.state;
    return (
      <Tooltip
        style={style}
        className={className}
        content={(
          <Button propsRef={ref => this.buttonRef = ref} type="primary" onClick={this.openEdit}>编辑表格</Button>
        )}>

        {this.props.children}

        <Drawer propsRef={ref => this.elementRef = ref} title="编辑数据" visible={visible} onClose={this.closeEdit}>
          {formContent}
        </Drawer>
      </Tooltip>
    )
  }
}

export default TooltipDrawer;



// WEBPACK FOOTER //
// src/routes/visualChart/components/TooltipDrawer/index.js